import axios from '@/Vue-Axios';

// GET 获取用户服务器迁移信息
export function getUserServerMigrationInfo() {
  return axios({
    method: 'get',
    url: `power/migrate-info`
  });
}